import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// Handles the #session_id=... fragment returned by Emergent Google Auth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/get-started", { replace: true }); return; }
    const sid = decodeURIComponent(m[1]);
    // Wipe the fragment so it's not left in browser history
    try { window.history.replaceState(null, "", window.location.pathname + window.location.search); } catch {}
    api.get("/auth/google/session", { headers: { "X-Session-ID": sid } })
      .then(({ data }) => {
        localStorage.setItem("pp_token", data.token);
        localStorage.setItem("pp_user", JSON.stringify(data.user));
        // Force a hard replace so AuthProvider re-reads localStorage
        window.location.replace("/store");
      })
      .catch((e) => {
        console.error("Google sign-in failed", e);
        toast.error("Google sign-in failed — please try again");
        navigate("/get-started", { replace: true });
      });
  }, [navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-orange-50 via-white to-amber-50">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-orange-500 animate-spin mx-auto mb-3" />
        <div className="font-display font-semibold text-slate-800">Signing you in with Google…</div>
        <div className="text-xs text-slate-500 mt-1">Setting up your free forever account</div>
      </div>
    </div>
  );
}
